<footer>
  <div class="copyright">
    &copy; {{ today | date: 'yyyy' }}, Imagekiwi
  </div>
</footer>
